// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c1ddd9ec","455":"7eecafae","977":"a396751b"}[chunkId] + ".chunk.js";
};